import React, { Component } from 'react';
import './Card.scss';
import Icon from '../Icon/Icon';
import Loading from './Loading';
import { manageMyAccount } from '../../settings/links.json';
import lineOfBusiness from '../../settings/lineOfBusiness.json';

export default class Card extends Component {
    getLOBSpecificInfo(lob, policy) {
        const isAuto = lineOfBusiness['auto'].includes(lob.toLowerCase());
        const isProperty = lineOfBusiness['property'].includes(lob.toLowerCase());

        if (isAuto) {
            const { vehicles } = policy;
            return (
                <div className="info">
                    <label>Vehicles on policy</label>
                    <div>
                        {vehicles.map(
                            vehicle => `${vehicle.year} ${vehicle.make} ${vehicle.model} \n`
                        )}
                    </div>
                </div>
            );
        }

        if (isProperty) {
            const { addressLineOne, addressLineTwo, city, state, zipcode } = policy.dwellingAddress;

            return (
                <div className="info">
                    <label>Dwelling location</label>
                    <div>
                        {`${addressLineOne.toLowerCase()} \n`}
                        {`${
                            addressLineTwo.toLowerCase() ? addressLineTwo.toLowerCase() + '\n' : ''
                        }`}
                        {`${city.toLowerCase()}, ${state} ${zipcode}`}
                    </div>
                </div>
            );
        }
        return null;
    }

    calculatePremiumChange(safecoPremium, priorCarrierPremium) {
        const change = parseFloat(safecoPremium) - parseFloat(priorCarrierPremium);

        return this.getCurrency(change) || '--';
    }

    getCurrency(num) {
        return new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(num);
    }

    getPolicyString(lob) {
        let policyString = lob;
        if (policyString.indexOf('policy') > -1) policyString.replace('policy', '');
        return policyString;
    }

    render() {
        const hasError = this.props.details.hasError;
        if (this.props.details.isLoading || !this.props.details.policyData)
            return <Loading hasError={hasError} />;

        const {
            policyData: { effectiveDate, safecoPremium, priorCarrierPremium, policyNumber, lob }
        } = this.props.details;

        return (
            <div className="card" datacy="policy-details">
                <a
                    href={manageMyAccount[this.props.deploy.env]}
                    target="_blank"
                    className="icon"
                    datacy="icon">
                    <Icon lob={lob} />
                    <span>{this.getPolicyString(lob)}</span>
                </a>
                <a
                    href={manageMyAccount[this.props.deploy.env]}
                    target="_blank"
                    className="policy-number"
                    datacy="policy-number">
                    {policyNumber}
                </a>
                <div className="info policy-effective-date">
                    <label>Policy effective</label>
                    <div>{effectiveDate}</div>
                </div>
                <div className="info safeco-premium">
                    <label>Safeco premium</label>
                    <div className="green">
                        <strong>{this.getCurrency(safecoPremium)}</strong>
                    </div>
                </div>
                <div className="info premium-change">
                    <label>Change</label>
                    <div>{this.calculatePremiumChange(safecoPremium, priorCarrierPremium)}</div>
                </div>
                <div className="info prev-premium">
                    <label>Previous carrier - last term premium</label>
                    <div>{this.getCurrency(priorCarrierPremium)}</div>
                </div>

                {this.getLOBSpecificInfo(lob, this.props.details.policyData)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Card/Card.jsx